import { analysisStep } from "./analysis-step";
import { analysisSetting } from "./analysis-setting";
import { analysisDelete } from "./analysis-delete";
import { analysisExport } from "./analysis-export";

export const reportMutations = {
  analysisStep,
  analysisSetting,
  analysisDelete,
  analysisExport,
};
